<div class="container">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    [attr.width]="compact ? '32px' : '64px'"
    [attr.height]="compact ? '42px' : '84px'"
    viewBox="0 0 64 84"
  >
    <defs>
      <linearGradient
        [attr.id]="pageGradientId | async"
        x1="-5.597"
        x2="44.986"
        y1="34.908"
        y2="90.605"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8D8DAF" stop-opacity=".05" />
        <stop offset="1" stop-color="#545477" stop-opacity=".05" />
      </linearGradient>
      <mask [attr.id]="pageMaskId | async" fill="white">
        <path
          fill-rule="evenodd"
          d="M0 29.907V80a4 4 0 0 0 4 4h56a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H29.907L0 29.907z"
          clip-rule="evenodd"
        />
      </mask>
      <mask
        [attr.id]="backgroundStripeMaskId | async"
        width="64"
        height="22"
        x="0"
        y="45"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="white"
          fill-rule="evenodd"
          d="M0 45h64v22H0V45z"
          clip-rule="evenodd"
        />
      </mask>
    </defs>

    <path
      class="page-fill"
      *ngIf="!empty"
      [attr.fill]="pageGradientUrl | async"
      fill-rule="evenodd"
      d="M0 29.907V80a4 4 0 0 0 4 4h56a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H29.907L0 29.907z"
      clip-rule="evenodd"
    />
    <path
      class="page-border"
      d="M0 29.9067V80C0 82.209 1.79089 84 4 84H60C62.2091 84 64 82.209 64 80V4C64 1.79102 62.2091 0 60 0H29.9067L0 29.9067Z"
      stroke="#DDDDE4"
      stroke-width="2"
      [attr.stroke-dasharray]="empty ? 4 : null"
      [attr.mask]="pageMaskUrl | async"
      fill="none"
    />
    <path
      class="dogear-fill"
      *ngIf="!empty"
      fill="#545477"
      fill-opacity=".05"
      fill-rule="evenodd"
      d="M25.907 29.907a4 4 0 0 0 4-4V0L0 29.907h25.907z"
      clip-rule="evenodd"
    />
    <path
      class="dogear-border"
      d="M29.9066 0V25.9067C29.9066 28.1157 28.1157 29.9067 25.9066 29.9067H-0.00012207"
      stroke="#DDDDE4"
      [attr.stroke-dasharray]="empty ? 4 : null"
      fill="none"
    />

    <ng-template #backgroundStripe let-color>
      <path
        class="background-stripe"
        [attr.fill]="color"
        fill-rule="evenodd"
        d="M0 45h64v22H0V45z"
        clip-rule="evenodd"
      />
    </ng-template>

    <ng-template #backgroundCircleAndSides let-color>
      <path
        class="circle-and-sides"
        [attr.fill]="color"
        fill-rule="evenodd"
        clip-rule="evenodd"
        [attr.mask]="backgroundStripeMaskUrl | async"
        d="M32 70c7.732 0 14-6.268 14-14s-6.268-14-14-14-14 6.268-14 14 6.268 14 14 14zM0 45h1v22H0V45zM63 45h1v22h-1V45z"
      />
    </ng-template>

    <ng-template #backgroundSidesOnly let-color>
      <path
        class="sides"
        [attr.fill]="color"
        fill-rule="evenodd"
        d="M0 45h1v22H0V45zM63 45h1v22h-1V45z"
        clip-rule="evenodd"
        [attr.mask]="backgroundStripeMaskUrl | async"
      />
    </ng-template>

    <ng-template #emptyBackground>
      <ng-container
        *ngTemplateOutlet="backgroundStripe; context: { $implicit: '#DDDDE4' }"
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          backgroundCircleAndSides;
          context: { $implicit: '#C1C1CE' }
        "
      ></ng-container>
    </ng-template>

    <ng-container *ngIf="type === DocumentIcon.ADD_FILE">
      <path
        class="icon"
        fill="#65658B"
        d="M41 52h-6v6h-2v-6h-6v-2h6v-6h2v6h6v2z"
      />
    </ng-container>

    <ng-container *ngIf="type === DocumentIcon.BENCHMARK">
      <ng-container
        *ngTemplateOutlet="backgroundStripe; context: { $implicit: '#FFF185' }"
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          backgroundCircleAndSides;
          context: { $implicit: '#CABC51' }
        "
      ></ng-container>
      <path
        class="icon"
        fill="white"
        transform="translate(20 44)"
        d="M3 19c0 1.1.9 2 2 2h4v-2H5v-4H3v4zM3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm9 3c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm9-9c0-1.1-.9-2-2-2h-4v2h4v4h2V5zm-2 14h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"
      />
    </ng-container>

    <ng-container *ngIf="type === DocumentIcon.CHARGEMASTER">
      <ng-container
        *ngIf="empty; then emptyBackground; else chargemasterBackground"
      ></ng-container>
      <ng-template #chargemasterBackground>
        <ng-container
          *ngTemplateOutlet="
            backgroundStripe;
            context: { $implicit: '#A8CFEB' }
          "
        ></ng-container>
        <ng-container
          *ngTemplateOutlet="
            backgroundCircleAndSides;
            context: { $implicit: '#659AC0' }
          "
        ></ng-container>
      </ng-template>
      <path
        class="icon"
        fill="white"
        d="M40.842 55.65l-7.5-7.5c-.3-.3-.717-.483-1.175-.483h-5.834c-.916 0-1.666.75-1.666 1.666v5.834c0 .458.183.874.491 1.183l7.5 7.5c.3.3.717.483 1.175.483a1.63 1.63 0 0 0 1.175-.491l5.834-5.834c.308-.3.491-.717.491-1.175 0-.458-.191-.883-.491-1.183zm-13.259-3.817c-.691 0-1.25-.558-1.25-1.25 0-.691.559-1.25 1.25-1.25.692 0 1.25.559 1.25 1.25 0 .692-.558 1.25-1.25 1.25z"
      />
    </ng-container>

    <ng-container *ngIf="type === DocumentIcon.CLAIM">
      <ng-container
        *ngIf="empty; then emptyBackground; else claimBackground"
      ></ng-container>
      <ng-template #claimBackground>
        <ng-container
          *ngTemplateOutlet="
            backgroundStripe;
            context: { $implicit: '#A8CFEB' }
          "
        ></ng-container>
        <ng-container
          *ngTemplateOutlet="
            backgroundCircleAndSides;
            context: { $implicit: '#659AC0' }
          "
        ></ng-container>
      </ng-template>
      <path
        class="icon"
        fill="white"
        fill-rule="evenodd"
        d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
        clip-rule="evenodd"
        transform="translate(20 44)"
      />
    </ng-container>

    <ng-container *ngIf="type === DocumentIcon.COST">
      <ng-container
        *ngIf="empty; then emptyBackground; else costBackground"
      ></ng-container>
      <ng-template #costBackground>
        <ng-container
          *ngTemplateOutlet="
            backgroundStripe;
            context: { $implicit: '#FFF185' }
          "
        ></ng-container>
        <ng-container
          *ngTemplateOutlet="
            backgroundCircleAndSides;
            context: { $implicit: '#CABC51' }
          "
        ></ng-container>
      </ng-template>
      <path
        class="icon"
        fill="white"
        fill-rule="evenodd"
        d="M33.605 47.05v1.678c1.724.25 3.335.953 4.492 2.269l-2.337 2.246c-1.111-1.293-2.495-1.815-3.607-1.724-.975 0-1.61.34-1.61.998 0 .748 1.111 1.043 2.835 1.474 2.065.567 4.832 1.18 4.832 4.401 0 2.631-2.019 4.038-4.628 4.355v1.883H31.27v-1.86c-2.11-.227-3.857-1.112-5.059-2.586l2.518-2.223c1.089 1.361 2.54 1.95 3.788 1.883.953-.023 1.497-.431 1.497-1.044 0-.816-1.157-1.066-2.835-1.588-2.02-.635-4.582-1.36-4.582-4.196 0-2.518 1.973-4.083 4.695-4.356v-1.61h2.314z"
        clip-rule="evenodd"
      />
    </ng-container>

    <ng-container *ngIf="type === DocumentIcon.DATA_SOURCE">
      <ng-container
        *ngIf="empty; then emptyBackground; else background"
      ></ng-container>
      <ng-template #background>
        <ng-container
          *ngTemplateOutlet="
            backgroundStripe;
            context: { $implicit: '#6AC67D' }
          "
        ></ng-container>
        <ng-container
          *ngTemplateOutlet="
            backgroundCircleAndSides;
            context: { $implicit: '#3D8A4D' }
          "
        ></ng-container>
      </ng-template>
      <path
        class="icon"
        fill="white"
        fill-rule="evenodd"
        d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"
        clip-rule="evenodd"
        transform="translate(20 44)"
      />
    </ng-container>

    <ng-container *ngIf="type === DocumentIcon.NPI">
      <ng-container
        *ngIf="empty; then emptyBackground; else npiBackground"
      ></ng-container>
      <ng-template #npiBackground>
        <ng-container
          *ngTemplateOutlet="
            backgroundStripe;
            context: { $implicit: '#6AC67D' }
          "
        ></ng-container>
        <ng-container
          *ngTemplateOutlet="
            backgroundCircleAndSides;
            context: { $implicit: '#3D8A4D' }
          "
        ></ng-container>
      </ng-template>
      <path
        class="icon"
        fill="white"
        transform="translate(20 44)"
        d="M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z"
      />
    </ng-container>

    <ng-container *ngIf="type === DocumentIcon.USAGE">
      <ng-container
        *ngIf="empty; then emptyBackground; else usageBackground"
      ></ng-container>
      <ng-template #usageBackground>
        <ng-container
          *ngTemplateOutlet="
            backgroundStripe;
            context: { $implicit: '#6AC67D' }
          "
        ></ng-container>
        <ng-container
          *ngTemplateOutlet="
            backgroundCircleAndSides;
            context: { $implicit: '#3D8A4D' }
          "
        ></ng-container>
      </ng-template>
      <path
        class="icon"
        fill="white"
        d="M38 50h-3v11h3V50zm-8 2h3v9h-3v-9zm-5 3h3v6h-3v-6z"
      />
    </ng-container>

    <ng-container *ngIf="type === DocumentIcon.USAGE_SCHEDULE">
      <ng-container
        *ngIf="empty; then emptyBackground; else usageScheduleBackground"
      ></ng-container>
      <ng-template #usageScheduleBackground>
        <ng-container
          *ngTemplateOutlet="
            backgroundStripe;
            context: { $implicit: '#E65452' }
          "
        ></ng-container>
        <ng-container
          *ngTemplateOutlet="
            backgroundCircleAndSides;
            context: { $implicit: '#8D2625' }
          "
        ></ng-container>
      </ng-template>
      <path
        class="icon"
        fill="white"
        transform="translate(20 44)"
        d="M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z"
      />
    </ng-container>

    <ng-container *ngIf="type === DocumentIcon.CSV">
      <ng-container
        *ngTemplateOutlet="backgroundStripe; context: { $implicit: '#6AC67D' }"
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          backgroundSidesOnly;
          context: { $implicit: '#3D8A4D' }
        "
      ></ng-container>
      <path
        class="icon"
        fill="white"
        d="M21.206 62.216c2.773 0 4.878-1.404 5.346-4.59h-1.907c-.36 2.178-1.674 2.916-3.402 2.916-2.178 0-3.636-1.656-3.636-4.446v-.144c0-2.772 1.476-4.446 3.672-4.446 1.674 0 2.933.684 3.33 2.772h1.925c-.521-3.078-2.555-4.446-5.237-4.446-3.259 0-5.545 2.448-5.545 6.192 0 3.726 2.268 6.192 5.454 6.192zm11.9-.018c2.7 0 4.301-1.512 4.301-3.69 0-2.34-2.015-2.952-3.977-3.33-1.71-.324-3.276-.576-3.276-1.854 0-1.152.918-1.908 2.393-1.908 1.639 0 2.629.666 2.88 2.412h1.926c-.36-2.682-2.105-3.996-4.788-3.996-2.447 0-4.193 1.512-4.193 3.582 0 2.304 2.105 2.952 4.086 3.348 1.727.324 3.15.648 3.15 1.836 0 1.26-.936 2.016-2.556 2.016-1.837 0-2.773-.666-3.133-2.43h-1.944c.468 2.592 2.088 4.014 5.13 4.014zm5.267-12.15L42.639 62h1.997l4.248-11.952h-1.871l-3.313 9.9-3.42-9.9h-1.907z"
      />
    </ng-container>

    <ng-container *ngIf="type === DocumentIcon.WORD">
      <ng-container
        *ngTemplateOutlet="backgroundStripe; context: { $implicit: '#2E539B' }"
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          backgroundSidesOnly;
          context: { $implicit: '#2E539B' }
        "
      ></ng-container>
      <path
        class="icon"
        fill="white"
        d="m 29.84,49.335 c 0.95,-0.055 1.9,-0.095 2.85,-0.145 0.665,3.375 1.345,6.745 2.065,10.105 0.565,-3.47 1.19,-6.93 1.795,-10.395 1,-0.035 2,-0.09 2.995,-0.15 -1.13,4.845 -2.12,9.73 -3.355,14.545 -0.835,0.435 -2.085,-0.02 -3.075,0.05 -0.6765,-3.31 -1.44,-6.6 -2.035,-9.925 -0.585,3.23 -1.345,6.43 -2.015,9.64 -0.96,-0.05 -1.925,-0.11 -2.89,-0.175 -0.83,-4.4 -1.805,-8.77 -2.58,-13.18 0.855,-0.04 1.715,-0.075 2.57,-0.105 0.515,3.185 1.1,6.355 1.55,9.545 0.705,-3.27 1.425,-6.54 2.125,-9.81 z"
      />
    </ng-container>

    <ng-container *ngIf="type === DocumentIcon.PDF">
      <ng-container
        *ngTemplateOutlet="backgroundStripe; context: { $implicit: '#E65452' }"
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          backgroundSidesOnly;
          context: { $implicit: '#8D2625' }
        "
      ></ng-container>
      <path
        class="icon"
        fill="white"
        d="M16.115 50.048V62h1.8v-4.41h1.926c3.276 0 4.914-1.224 4.914-3.798 0-2.52-1.584-3.744-4.86-3.744h-3.78zm1.8 1.53h1.98c2.16 0 3.024.63 3.024 2.214 0 1.638-.918 2.268-3.078 2.268h-1.926v-4.482zM27.13 62h3.96c3.997 0 6.175-2.07 6.175-5.94 0-3.942-2.106-6.012-5.994-6.012h-4.14V62zm1.8-10.368h2.34c2.79 0 4.105 1.368 4.105 4.356v.108c0 2.898-1.404 4.32-4.23 4.32H28.93v-8.784zM46.051 55.25h-4.716v-3.6h6.21v-1.602h-8.01V62h1.8v-5.148h4.716V55.25z"
      />
    </ng-container>

    <ng-container *ngIf="type === DocumentIcon.SCHEDULE">
      <ng-container
        *ngTemplateOutlet="backgroundStripe; context: { $implicit: '#A8CFEB' }"
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          backgroundCircleAndSides;
          context: { $implicit: '#659AC0' }
        "
      ></ng-container>
      <path
        class="icon"
        fill="white"
        transform="translate(20 44)"
        d="M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z"
      />
    </ng-container>

    <ng-container *ngIf="type === DocumentIcon.XLS">
      <ng-container
        *ngTemplateOutlet="backgroundStripe; context: { $implicit: '#42AB58' }"
      ></ng-container>
      <ng-container
        *ngTemplateOutlet="
          backgroundSidesOnly;
          context: { $implicit: '#105D20' }
        "
      ></ng-container>
      <path
        class="icon"
        fill="white"
        d="M24.623 50.048l-2.988 4.5-2.808-4.5h-1.98l3.744 5.868L16.45 62h2.016l3.168-4.788L24.623 62h2.016l-3.942-6.192 3.906-5.76h-1.98zm5.837 0h-1.8V62h7.434v-1.62H30.46V50.048zm11.834 12.15c2.7 0 4.302-1.512 4.302-3.69 0-2.34-2.016-2.952-3.978-3.33-1.71-.324-3.276-.576-3.276-1.854 0-1.152.918-1.908 2.394-1.908 1.638 0 2.628.666 2.88 2.412h1.926c-.36-2.682-2.106-3.996-4.788-3.996-2.448 0-4.194 1.512-4.194 3.582 0 2.304 2.106 2.952 4.086 3.348 1.728.324 3.15.648 3.15 1.836 0 1.26-.936 2.016-2.556 2.016-1.836 0-2.772-.666-3.132-2.43h-1.944c.468 2.592 2.088 4.014 5.13 4.014z"
      />
    </ng-container>
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    *ngIf="needsAttention"
    class="attention"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="12" r="11.5" fill="#E65452" stroke="#C52422" />
    <path
      fill="#FFFFFF"
      d="M9.65 5.12h4.7v.04l-2.12 9.48h-.44L9.65 5.16v-.04zm4.12 10.46V19h-3.54v-3.42h3.54z"
    />
  </svg>
</div>
